import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslator } from '@gandi/translate';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import { selectRawBundleById } from '../../../../modules/bundles';
import Item from './Item';
import { NO_PRICE, useGetTotalPrice, useGetCartBundlePrice, useBundleDescription } from './helpers';
import { removeBundleFactory } from './modules/actions';
import { jsx as _jsx } from "react/jsx-runtime";
export default function BundleItem({
  bundle
}) {
  const translator = useTranslator();
  const dispatch = useDispatch();
  const rawBundle = useAppSelector(state => selectRawBundleById(state, bundle.id));
  const getTotalPrice = useGetTotalPrice();
  const getBundlePrice = useGetCartBundlePrice();
  const bundleDescription = useBundleDescription(bundle);
  const isDomainBundle = !rawBundle?.is_partial_type && bundle.products.every(product => product.productType === 'domain');
  const promoLabels = [];
  const details = bundle.products.filter(({
    label
  }) => !!label).sort(({
    productType
  }) => productType === 'paas' ? -1 : 1).map(product => {
    if (!!product.discounts?.length && product.discounts[0].description) promoLabels.push(product.discounts[0].description);
    return {
      label: product.label,
      price: isDomainBundle || !product.total ? undefined : getTotalPrice(product.total),
      isFqdn: true
    };
  });
  if (promoLabels.length === 3) {
    details.push({
      label: 'BUNDLE',
      isPromo: true,
      isFqdn: false,
      price: undefined
    });
  }
  const {
    price,
    crossedPrice
  } = getBundlePrice(bundle);
  return /*#__PURE__*/_jsx(Item, {
    price: Number.isNaN(price) ? NO_PRICE : price,
    title: bundleDescription,
    details: details,
    handleRemoveAction: removeBundleFactory({
      translator,
      dispatch,
      bundle
    }),
    productType: "domain",
    crossedPrice: crossedPrice
  });
}